import {
  ChartRow,
  ChartRowElement,
  ChartRowGroup,
  ChartSubsection,
  ChartSubsectionContent,
  ChartSubsectionHeader,
} from "modules/charts-shared";
import { RADIOLOGY_GRID_COLUMNS } from "../radiology-chart/constants";
import { RadiologyInterpretationProps } from "../radiology-chart/types";

function F007Interpretation(props: RadiologyInterpretationProps) {
  const {
    index,
    chartCode,
    encounterId,
    sectionId,
    sectionCode,
    sectionSubCode,
    onRemoveElement,
  } = props;

  const sectionDelimiter = `rad.${index}.${chartCode}${sectionId}${sectionCode}${sectionSubCode}`;

  return (
    <ChartSubsection
      header={
        <ChartSubsectionHeader
          showNotesBtn
          showDeleteBtn
          chartId={chartCode}
          encounterId={encounterId}
          sectionId={sectionCode}
          showInteractions={false}
          subsectionId={`${sectionSubCode}_Q001`}
          subsectionLabel="Facial"
          showAuditsBtn={false}
          onDeleteSubSection={() => onRemoveElement(sectionId)}
        />
      }
      content={
        <ChartSubsectionContent>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement
                label="Facial"
                name={`${sectionDelimiter}Q001A001`}
                type="cross-option"
              />
              <ChartRowElement
                label="L"
                name={`${sectionDelimiter}Q001A002`}
                type="cross-option"
              />
              <ChartRowElement
                label="R"
                name={`${sectionDelimiter}Q001A003`}
                type="cross-option"
              />
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="nasal"
                name={`${sectionDelimiter}Q001A004`}
                type="cross-option"
              />
              <ChartRowElement
                label="orbit"
                name={`${sectionDelimiter}Q001A005`}
                type="cross-option"
              />
              <ChartRowElement
                label="malar"
                name={`${sectionDelimiter}Q001A006`}
                type="cross-option"
              />
              <ChartRowElement
                label="maxilla"
                name={`${sectionDelimiter}Q001A007`}
                type="cross-option"
              />
              <ChartRowElement
                label="zygoma"
                name={`${sectionDelimiter}Q001A008`}
                type="cross-option"
              />
              <ChartRowElement
                label="Le Fort:"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A009`}
                type="cross-option"
              />
              <ChartRowElement
                label="I"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A010`}
                type="cross-option"
              />
              <ChartRowElement
                label="II"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A011`}
                type="cross-option"
              />
              <ChartRowElement
                label="III"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A012`}
                type="cross-option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A013`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="mandible:"
                name={`${sectionDelimiter}Q001A014`}
                type="cross-option"
              />
              <ChartRowElement
                label="ramus"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A015`}
                type="cross-option"
              />
              <ChartRowElement
                label="angle"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A016`}
                type="cross-option"
              />
              <ChartRowElement
                label="body"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A017`}
                type="cross-option"
              />
              <ChartRowElement
                label="condyle"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A018`}
                type="cross-option"
              />
              <ChartRowElement
                label="subcondyle"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A019`}
                type="cross-option"
              />
              <ChartRowElement
                label="symphysis"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A020`}
                type="cross-option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A021`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                name={`${sectionDelimiter}Q001A022`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
        </ChartSubsectionContent>
      }
    />
  );
}

export { F007Interpretation };
